import { http, createConfig } from 'wagmi'
import { mainnet } from 'wagmi/chains'
import { injected, metaMask, safe, walletConnect } from 'wagmi/connectors'

const projectId = '75f0ab21a52cbff7e566bcc9be983646'

// const sepolia = {
//   "id": 11155111,
//   "network": "sepolia",
//   "name": "Sepolia",
//   "nativeCurrency": {
//     "name": "Sepolia",
//     "symbol": "ETH",
//     "decimals": 18
//   },
//   "rpcUrls": {
//     "default": {
//       "http": [
//         "https://ethereum-sepolia-rpc.publicnode.com"
//       ]
//     },
//     "public": {
//       "http": [
//         "https://ethereum-sepolia-rpc.publicnode.com"
//       ]
//     }
//   },
//   "blockExplorers": {
//     "default": {
//       "name": "Sepolia.etherscan",
//       "url": "https://sepolia.etherscan.io"
//     },
//     "etherscan": {
//       "name": "Sepolia.etherscan",
//       "url": "https://sepolia.etherscan.io"
//     }
//   },
//   "contracts": {
//     "multicall3": {
//       "address": "0xca11bde05977b3631167028862be2a173976ca11",
//       "blockCreated": 5022
//     }
//   }
// }

export const config = createConfig({
  chains: [mainnet],
  connectors: [injected(), walletConnect({ projectId }),], 
  ssr: true,
  transports: {
   [mainnet.id]: http()
  },
})